import { useLanguageStore } from '@/store/languageStore.js';

export default function TranslateFunc(key) {
    if(!key || key == '') {
        return key;
    }
    const languageStore = useLanguageStore();
    return languageStore.getTranslation(key);
}